/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateApiSmsRouteDto } from '../model/createApiSmsRouteDto';
import { CreateSmppSmsRouteDto } from '../model/createSmppSmsRouteDto';
import { SmsRoute } from '../model/smsRoute';
import { SmsRouteDtos } from '../model/smsRouteDtos';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SmsRouteService {

    protected basePath = 'http://10.1.1.123:30118';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRouteCheckHealthNow(observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smsRouteCheckHealthNow(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smsRouteCheckHealthNow(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smsRouteCheckHealthNow(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/api/SmsRoute`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param smsRouteId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRouteDeleteSmsRoute(smsRouteId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public smsRouteDeleteSmsRoute(smsRouteId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public smsRouteDeleteSmsRoute(smsRouteId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public smsRouteDeleteSmsRoute(smsRouteId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (smsRouteId === null || smsRouteId === undefined) {
            throw new Error('Required parameter smsRouteId was null or undefined when calling smsRouteDeleteSmsRoute.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<any>(`${this.basePath}/api/SmsRoute/DeleteSmsRoute`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRouteGet(creatorId?: number, observe?: 'body', reportProgress?: boolean): Observable<SmsRouteDtos>;
    public smsRouteGet(creatorId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsRouteDtos>>;
    public smsRouteGet(creatorId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsRouteDtos>>;
    public smsRouteGet(creatorId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsRouteDtos>(`${this.basePath}/api/SmsRoute/Get`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRouteGetByServiceProviderId(serviceProviderId?: number, observe?: 'body', reportProgress?: boolean): Observable<SmsRouteDtos>;
    public smsRouteGetByServiceProviderId(serviceProviderId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsRouteDtos>>;
    public smsRouteGetByServiceProviderId(serviceProviderId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsRouteDtos>>;
    public smsRouteGetByServiceProviderId(serviceProviderId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsRouteDtos>(`${this.basePath}/api/SmsRoute/GetByServiceProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param smsRouteName 
     * @param creatorId 
     * @param includedefault 
     * @param serverType 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRouteGetSkipTake(smsRouteName?: string, creatorId?: number, includedefault?: boolean, serverType?: number, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<SmsRouteDtos>;
    public smsRouteGetSkipTake(smsRouteName?: string, creatorId?: number, includedefault?: boolean, serverType?: number, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsRouteDtos>>;
    public smsRouteGetSkipTake(smsRouteName?: string, creatorId?: number, includedefault?: boolean, serverType?: number, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsRouteDtos>>;
    public smsRouteGetSkipTake(smsRouteName?: string, creatorId?: number, includedefault?: boolean, serverType?: number, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (smsRouteName !== undefined && smsRouteName !== null) {
            queryParameters = queryParameters.set('smsRouteName', <any>smsRouteName);
        }
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (includedefault !== undefined && includedefault !== null) {
            queryParameters = queryParameters.set('includedefault', <any>includedefault);
        }
        if (serverType !== undefined && serverType !== null) {
            queryParameters = queryParameters.set('serverType', <any>serverType);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsRouteDtos>(`${this.basePath}/api/SmsRoute/GetSkipTake`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param smsRouteId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRouteGetSmsRouteById(smsRouteId: string, observe?: 'body', reportProgress?: boolean): Observable<SmsRoute>;
    public smsRouteGetSmsRouteById(smsRouteId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsRoute>>;
    public smsRouteGetSmsRouteById(smsRouteId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsRoute>>;
    public smsRouteGetSmsRouteById(smsRouteId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (smsRouteId === null || smsRouteId === undefined) {
            throw new Error('Required parameter smsRouteId was null or undefined when calling smsRouteGetSmsRouteById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.get<SmsRoute>(`${this.basePath}/api/SmsRoute/GetSmsRouteById`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutePostApiSmsRoute(model: CreateApiSmsRouteDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smsRoutePostApiSmsRoute(model: CreateApiSmsRouteDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smsRoutePostApiSmsRoute(model: CreateApiSmsRouteDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smsRoutePostApiSmsRoute(model: CreateApiSmsRouteDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsRoutePostApiSmsRoute.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/SmsRoute/PostApiSmsRoute`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRoutePostSmppSmsRoute(model: CreateSmppSmsRouteDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smsRoutePostSmppSmsRoute(model: CreateSmppSmsRouteDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smsRoutePostSmppSmsRoute(model: CreateSmppSmsRouteDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smsRoutePostSmppSmsRoute(model: CreateSmppSmsRouteDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsRoutePostSmppSmsRoute.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/SmsRoute/PostSmppSmsRoute`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsRouteUpdateSmsRoute(model: SmsRoute, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public smsRouteUpdateSmsRoute(model: SmsRoute, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public smsRouteUpdateSmsRoute(model: SmsRoute, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public smsRouteUpdateSmsRoute(model: SmsRoute, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsRouteUpdateSmsRoute.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/api/SmsRoute/UpdateSmsRoute`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
